export default "__VITE_ASSET__7880e88a__"